<nb-card [accent]="status">
    <nb-card-header class="{{status}}">
        <div class="close-button" *ngIf="!show_cancel_button">
            <button nbButton ghost (click)="dismiss()">
                <nb-icon icon="close-outline" class="close-icon"></nb-icon>
            </button>
        </div>
        <nb-icon icon="{{setIcon(status)}}"></nb-icon>
        <h6>
            {{ header }}
        </h6>
    </nb-card-header>
    <nb-card-body [innerHtml]="body">
    </nb-card-body>
    <nb-card-footer>
        <button class="float-right" nbButton status="basic" (click)="dismiss()" ghost status="basic"
            *ngIf="show_cancel_button">{{ btn_cancel_name
            }}</button>
        <button class="float-right" nbButton [status]="status" (click)="confirm()" ghost status="primary">{{
            btn_action_name }}</button>
    </nb-card-footer>
</nb-card>